// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, AUTH_MENU, SET_PROJECT } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    name: null,
    user_id: null,
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//
/**
 * accountReducer
 *
 * @summary Manages the authentication and account state for the application.
 *
 * @description
 * Handles actions to initialize the account, log in, log out, and update the authorized menu. Updates state properties such as login status, user info, token, permissions, project, and menu items based on the dispatched action.
 *
 * @param {Object} state - The current account state.
 * @param {Object} action - The dispatched Redux action.
 *
 * @returns {Object} The updated account state.
 *
 * @example
 * const newState = accountReducer(state, action);
 */
const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, user_id, token, permissions, authMenu, refresh, project } = action.payload;
            return {
                ...state,
                isLoggedIn:isLoggedIn,
                isInitialized: true,
                token: token,
                user : user,
                user_id : user_id,
                authMenu: authMenu,
                permissions:permissions,
                refresh: refresh,
                project: project,
                loginTime: new Date(),
            };
        }
        case LOGIN: {
            const { user, name, role, id, user_id } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user,
                user_id
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null,
                authMenu: null,
                permissions:null,
                user_id: null
            };
        }
        case AUTH_MENU: {
            const { menuItem } = action.payload;
            return {
                ...state,
                menuItem 
            }
        }
        case SET_PROJECT:
            return {
                ...state,
                project: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
